<template>
  <form class="form" action="#">
    <div class="form-fields">
      <div class="mb-3">
        <div class="mb-2 -mt-6 text-xs font-semibold">Notification Medium*</div>
        <div class="flex pb-4">
          <div v-for="(m, index) in mediums" :key="`notification-m-${index}`" class="ratio pr-4">
            <input
              class="ratio-input"
              :id="m.name"
              type="radio"
              :value="m.value"
              v-model="medium"
            />
            <label class="ratio-label" :for="m.name"></label>
            <span class="ratio-name">{{ m.name }}</span>
          </div>
        </div>
      </div>
      <div>
        <VFormInput
          label="Notification Title*"
          placeholder="Enter title"
          :initialValue="initialValues.title"
          :error="errors.title"
          @update="value => $emit('set', 'title', value)"
        />
      </div>
      <div>
        <VFormTextarea
          label="Notification Content*"
          placeholder="Enter content"
          :initialValue="initialValues.content"
          :error="errors.content"
          @update="value => $emit('set', 'content', value)"
        />
      </div>

      <div class="flex items-center">
        <div class="min-w-32 -mt-10">
          <VFormCheckbox
            label="Is external link*"
            :initialValue="initialValues.is_external || false"
            @update="value => $emit('set', 'is_external', value)"
            :isToggle="true"
          />
        </div>
        <VFormInput
          label="Link Text"
          placeholder="Enter link text"
          :initialValue="initialValues.link_text"
          :error="errors.link_text"
          @update="value => $emit('set', 'link_text', value)"
        />
      </div>

      <div>
        <VFormInput
          label="Link URL"
          placeholder="Enter link url"
          :initialValue="initialValues.link_url"
          :error="errors.link_url"
          @update="value => $emit('set', 'link_url', value)"
        />
      </div>
    </div>
  </form>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormTextarea from '@/components/base/VFormTextarea';
import VFormCheckbox from '@/components/base/VFormCheckbox';

export default {
  name: 'AdminNotificationsForm',
  components: { VFormInput, VFormTextarea, VFormCheckbox },
  props: {
    mediums: {
      type: Array,
      required: false,
      default: () => [],
    },
    initialValues: {
      type: Object,
      requried: false,
      default: () => ({}),
    },
    errors: {
      type: Object,
      requried: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      medium: 'PORTAL',
    };
  },
  watch: {
    medium(val) {
      this.$emit('set', 'medium', val);
    },
  },
  mounted() {
    const medium = this.initialValues.medium;
    medium
      ? ((this.medium = medium), this.$emit('set', 'medium', this.medium))
      : this.$emit('set', 'medium', this.medium);
  },
};
</script>
